import React from "react";
import styles from "../styles/Forgot-Password.module.css";
import ForgotCard from "../components/SignUpCard";
import forgot from "../assets/images/thinking.png"
import back from "../assets/svgs/back.svg";
import { useFormik } from "formik";
import * as yup from "yup";
import caution from "../assets/svgs/caution.svg";

const passwordRules = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*?&]).{8,}$/;
// Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character

const FormSchema = yup.object().shape({
  password: yup
    .string()
    .min(8)
    .matches(passwordRules, { message: "Please create a stronger password" })
    .required("Required"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password"), null], "Passwords must match")
    .required("Required"),
});

const ForgotP = () => {
  const formik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema: FormSchema,
  });
  console.log(formik);
  return (
    <div className={styles.container}>
      
        <ForgotCard image = {forgot} />
      

      <div className={styles.forgotPassword}>
        <img src={back} alt="" className={styles.backSvg} />
        <span>
          <a href="/login" className={styles.back}>
            Back
          </a>
        </span>
        <h3 className={styles.header}>Forgot password</h3>
        <p className={styles.headerText}>Please enter a new password</p>
        <form onSubmit={formik.handleSubmit} action="">
          <label htmlFor="password" className={styles.lbl}>
            New Password
          </label>
          <input
            value={formik.values.password}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            type="password"
            id="password"
            className={
              formik.errors.password && formik.touched.password
                ? styles.input
                : ""
            }
          />
          {formik.errors.password && formik.touched.password && (
            <p className={styles.error}>
              <img src={caution} alt="" className={styles.caution} />
              {formik.errors.password}
            </p>
          )}

          <label htmlFor="confirmPassword" className={styles.lbl}>
            Confirm Password
          </label>
          <input
            type="password"
            value={formik.values.confirmPassword}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            id="confirmPassword"
            className={
              formik.errors.confirmPassword && formik.touched.confirmPassword
                ? styles.input
                : ""
            }
          />
          {formik.errors.confirmPassword && formik.touched.confirmPassword && (
            <p className={styles.error}>
              <img src={caution} alt="" className={styles.caution} />
              {formik.errors.confirmPassword}
            </p>
          )}
          <button
            disabled={formik.isSubmitting}
            type="submit"
            className={styles.button}
          >
            Done
          </button>
          <p className={styles.register}>
            Don't have an account?{" "}
            <span className={styles.regbtn}>
              <a href="/register">Register</a>
            </span>
          </p>
        </form>
      </div>
    </div>
  );
};

export default ForgotP;
